import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

class ViewRole extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            noLinks: false
        };


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.data = {};
        this.data.Role = null;

        if (this.props.Role){
            this.data.Role = this.props.Role; 
        }

        if (this.props.noLinks){
            this.state.noLinks = this.props.noLinks; 
        }


        this.filters = {};

        this.columns = {
        };

        this.data.id = null;
        if (this.props.id){
            this.data.id = this.props.id; 
        }


    }

    componentDidMount() {

        if (this.data.Role){
            this.setState({"isLoaded":true});
            return;
        }

    };

    view(json){

        if (json){
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                


                        {hasProperty(json,'type') &&
                            <PD.Tr>                                
                                <PD.Th>Type</PD.Th><PD.Td>{json.type}</PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th>
                                <PD.Td>
                                    {(() => {
                                        switch (this.state.noLinks) {
                                            case true:
                                                return json.name
                                            default:
                                                return (
                                                    <PD.PdNavLink to={"/role/" + json._id} >
                                                        {json.name}
                                                    </PD.PdNavLink>
                                                )
                                        }
                                    })()}
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'Specialises') && hasProperty(json.Specialises,'Role') &&
                            <PD.Tr>                                
                                <PD.Th>Specialises</PD.Th>
                                <PD.Td>
                                    <PD.PdNavLink to={"/role/" + json.Specialises.Role._id} > {json.Specialises.Role.name}</PD.PdNavLink>
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'proposals') &&
                            <PD.Tr>
                                <PD.Th>Proposals</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.proposals}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'status') &&
                            <PD.Tr>                                
                                <PD.Th>Status</PD.Th><PD.Td>{json.status}</PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'Solution') &&
                            <>
                                <PD.Tr>                                
                                    <PD.Th>Solution</PD.Th>
                                    <PD.Td>    
                                        <PD.PdNavLink to={"/solution/" + json.Solution._id} > {json.Solution.name}</PD.PdNavLink>
                                    </PD.Td>
                                </PD.Tr>

                                {json.Solution.Owner &&
                                    <PD.Tr>
                                        <PD.Th>Owner</PD.Th><PD.Td>{json.Solution.Owner.organisation}</PD.Td>
                                    </PD.Tr>
                                }
                            </>

                        }


                    </PD.Tbody>
                </PD.Table>
            )
        };
        return null;
    };

    render() {

        if (this.state.isLoaded) {

            return (
                <div>
                    {this.view(this.data.Role)}
                </div>
            )
        }
        else {
            return <div />;
        }

    };    
};
        
export default ViewRole;